module.exports = __webpack_public_path__ + "static/media/blog1Img.ba832bd5.webp";